import { actionTypes, eventNames } from 'app/constants/AnalyticsGa4Constants';
import HoldsConstants from 'app/constants/HoldsConstants';
import {
  selectBibEntity,
  selectOrganizationEntity,
  selectProductEntity,
  selectUserEntity
} from 'app/selectors/AnalyticsGa4Selector';

const DATA_LAYER_NAME = 'dataLayer';

const pushEvent = event => {
  (window[DATA_LAYER_NAME] || (window[DATA_LAYER_NAME] = [])).push(event);
};

export default function AnalyticsGa4Middleware() {
  return ({ getState }) => next => action => {
    if (__SERVER__) {
      return next(action);
    }

    const { type } = action;
    const state = getState();

    switch (type) {
      case HoldsConstants.PLACE_HOLD_SUCCESS: {
        const event = {
          event: eventNames.HOLD_PLACE,
          entities: {
            bib: selectBibEntity(state, action.payload.id).toJS(),
            organization: selectOrganizationEntity(state).toJS(),
            product: selectProductEntity(state).toJS(),
            user: selectUserEntity(state)?.toJS() ?? null
          },
          event_properties: null
        };

        pushEvent(event);

        break;
      }

      case actionTypes.TRACK_PAGE_VIEW: {
        const event = {
          event: eventNames.PAGE_VIEW,
          entities: {
            organization: selectOrganizationEntity(state).toJS(),
            product: selectProductEntity(state).toJS(),
            user: selectUserEntity(state)?.toJS() ?? null
          },
          event_properties: null
        };

        pushEvent(event);

        break;
      }
      default: {
        break;
      }
    }

    return next(action);
  };
}
